/**
 * Promise.withResolvers for browsers that lack it (Safari < 17.4, Chrome < 119). pdf.js (react-pdf) calls it,
 * so the sample/book PDF viewer imports this module first. It used to ride in public/js/speed-fix.js, which every
 * page loaded before hydration; now only the PDF viewer pays for it. Side-effect module: import it for its effect.
 */
type WithResolvers = <T>() => { promise: Promise<T>; resolve: (value: T | PromiseLike<T>) => void; reject: (reason?: unknown) => void };

const P = Promise as unknown as { withResolvers?: WithResolvers };

if (typeof P.withResolvers !== 'function') {
  P.withResolvers = function withResolvers<T>() {
    let resolve!: (value: T | PromiseLike<T>) => void;
    let reject!: (reason?: unknown) => void;
    const promise = new Promise<T>((res, rej) => { resolve = res; reject = rej; });
    return { promise, resolve, reject };
  };
}

export {};
